import { getCustomerDisplayName } from '@/utils/customer';
import type { Conversation, Customer } from '@/types';

/**
 * Visible counterpart label for a conversation (#1585).
 * CRM / WhatsApp profile name first, then the phone, then a localized fallback.
 */
export function getConversationPartyName(
  customer: Pick<Customer, 'firstName' | 'lastName' | 'phone'> & {
    customerType?: Customer['customerType'];
    businessName?: Customer['businessName'];
  },
  unknownLabel: string,
): string {
  const named = getCustomerDisplayName(customer);
  if (named) {
    return named;
  }
  const phone = customer.phone?.trim() ?? '';
  return phone || unknownLabel;
}

export function getConversationPartyPhone(customer: Pick<Customer, 'phone'>): string {
  return customer.phone?.trim() ?? '';
}

/**
 * List and header title of a conversation. A mailbox email thread that matched
 * no single customer (#3736) is named by its sender address.
 */
export function getConversationTitle(
  conversation: Pick<Conversation, 'customer' | 'email'>,
  unknownLabel: string,
): string {
  if (conversation.email && !conversation.email.linked) {
    return conversation.email.address?.trim() || unknownLabel;
  }
  return getConversationPartyName(conversation.customer, unknownLabel);
}
